/** @jsx jsx */

import { jsx } from '@emotion/core';
import React from 'react';
import styles from './styles';
type PropTypes = {
  className?: string;
};

const Title: React.FC<PropTypes> = props => {
  const { children, className } = props;
  return (
    <h1 css={styles.titleText} className={className}>
      {children}
    </h1>
  );
};

export default Title;
